import _ from "lodash";
import { useEffect } from "react";

export const useHitBottom = ({ fetch }: { fetch: () => void }) => {
    useEffect(() => {
        const callback = _.throttle(() => {
            if (
                window.innerHeight + window.scrollY + 100 >=
                document.body.offsetHeight
            ) {
                fetch();
            }
        }, 300);

        window.addEventListener("scroll", callback);

        return () => window.removeEventListener("scroll", callback);
    }, [fetch]);
};
